export const NON_DIGIT_REGEX = /[^0-9]/g;

const PERCENT_MULTIPLIER = 100;
const PERCENT_FRACTION_DIGITS = 1;

export function formatNumber(n: number): string {
  return n.toLocaleString('ko-KR');
}

export function formatCurrency(n: number): string {
  return `${formatNumber(n)}원`;
}

export function formatPercent(ratio: number): string {
  return `${(ratio * PERCENT_MULTIPLIER).toFixed(PERCENT_FRACTION_DIGITS)}%`;
}

export function normalizeAccountNumber(value: string): string {
  return value.replace(NON_DIGIT_REGEX, '');
}

function pad2(n: number): string {
  return String(n).padStart(2, '0');
}

export function formatKoreanDate(iso: string): string {
  const d = new Date(iso);
  return `${d.getFullYear()}.${pad2(d.getMonth() + 1)}.${pad2(d.getDate())}`;
}

export function formatKoreanDateTime(iso: string): string {
  const d = new Date(iso);
  return `${formatKoreanDate(iso)} ${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}

export function formatNullableKoreanDateTime(iso: string | null): string {
  if (iso === null) return '-';
  return formatKoreanDateTime(iso);
}
